// extracted by mini-css-extract-plugin
export default {"tabletImg":"UG","desktopImg":"VG","mobileImg":"WG","backgroundImage":"XG","content":"YG","rtbLeft":"ZG","rtbRight":"aH","imageContainer":"bH","rtbBox":"cH","line":"eH"};
    if(module.hot) {
      // 1721922364467
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  